import React from "react";
import "./ServiceCenter.css";
import { Link } from "react-router-dom";

function ServiceCenter() {
  return (
    <>
      <section className="ServiceCenter">
        <div className="service-center">
          <h4 className="service-title">Service center</h4>

          <div className="service-grid">
            <Link to={"/setting-center"}>
              <div className="service-item">
                <div className="service-icon">
                  <div className="img_holder">
                    <img
                      src="/assets/images/icons/setting.png"
                      className="icon_img"
                      alt="icon img"
                    />
                  </div>
                </div>
                <p>Settings</p>
              </div>
            </Link>

            <Link to={"/feedback"}>
              <div className="service-item">
                <div className="service-icon">
                  <div className="img_holder">
                    <img
                      src="/assets/images/icons/notes.png"
                      className="icon_img"
                      alt="icon img"
                    />
                  </div>
                </div>
                <p>Feedback</p>
              </div>
            </Link>

            <Link to={"/announcement"}>
              <div className="service-item">
                <div className="service-icon">
                  <div className="img_holder">
                    <img
                      src="/assets/images/icons/announcement.png"
                      className="icon_img"
                      alt="icon img"
                    />
                  </div>
                </div>
                <p>Announcement</p>
              </div>
            </Link>

            <Link to={"/self-service-center"}>
              <div className="service-item">
                <div className="service-icon">
                  <div className="img_holder">
                    <img
                      src="/assets/images/icons/chat.png"
                      className="icon_img"
                      alt="icon img"
                    />
                  </div>
                </div>
                <p>Customer service</p>
              </div>
            </Link>

            <Link to={"/beginners-guide"}>
              <div className="service-item">
                <div className="service-icon">
                  <div className="img_holder">
                    <img
                      src="/assets/images/icons/open_book.png"
                      className="icon_img"
                      alt="icon img"
                    />
                  </div>
                </div>
                <p>Beginners Guide</p>
              </div>
            </Link>

            <Link to={"/about-us"}>
              <div className="service-item">
                <div className="service-icon">
                  <div className="img_holder">
                    <img
                      src="/assets/images/icons/box.png"
                      className="icon_img"
                      alt="icon img"
                    />
                  </div>
                </div>
                <p>About us</p>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default ServiceCenter;
